const formateColumnFilter = (column, columnFilter) => {
    const filterColumn = column.map(({ Header, accessor, type }) => ({
        Header,
        accessor,
        type,
    }));
    let filterQuery = "";
    let filterData = [];
    Object.entries(columnFilter).forEach(([key, value]) => {
        var columnDetail = column.find((val) => {
            return val.accessor === key;
        });
        if (columnDetail.type !== "Boolean") {
            if (value && typeof value === "number") {
                filterData.push(`${key.includes(".") ? key.replace(".", "/") : key} eq ${value}`);
            } else if (value) {
                filterData.push(
                    `contains(tolower(${key.includes(".") ? key.replaceAll(".", "/") : key}),tolower('${value.replaceAll("'", "''").toString()}'))`
                );
            }
        }
    });

    filterQuery = filterData.length > 0 ? filterData.join(" and ") : "";
    return { filterColumn, filterQuery };
}

export {
    formateColumnFilter
}
